import { createContext, useContext } from "react";

export interface TechFilterResetContextValue {
  /**
   * Reset tech filter values and trigger search
   * @param filterUids - Optional list of filter UIDs to reset. If not provided, resets all filters.
   */
  resetFilters: (filterUids?: string[]) => void;
}

export const TechFilterResetContext = createContext<TechFilterResetContextValue | undefined>(undefined);

export const useTechFilterReset = () => {
  const context = useContext(TechFilterResetContext);
  if (!context) {
    throw new Error("useTechFilterReset must be used within a TechFilterResetContext.Provider");
  }
  return context;
};
